require.resolve("!/usr/share/hubspot/build/.bpm/packages/bender-build-tools/static-1.2573/node_modules/bender-lyaml-loader/lib/postmodern.js!./en.lyaml?sporks");

export default {
  mode: "sync",
  source: "quartz-core/lang",
  context: {
    "en": function () { return require("!/usr/share/hubspot/build/.bpm/packages/bender-build-tools/static-1.2573/node_modules/bender-lyaml-loader/lib/postmodern.js!./en.lyaml?sporks" /* webpackChunkName: "quartz-core-lang-en" */); }  }
};
